import React from 'react';
import { SelectNewDetailType } from '../../../../_StandardRutin/StandardRutin';

interface IBusinessDataSetContext {
  refetch: () => void;
  selectNewDetail: SelectNewDetailType;
}

const BusinessDataSetContext = React.createContext<IBusinessDataSetContext>({
  refetch: () => {},
  selectNewDetail: () => {},
});

export default BusinessDataSetContext;
